import React, { useReducer, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import { dataFetchReducer } from "../../../Utils/requestUtils"
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from '@material-ui/icons/Clear';
import { useTranslation } from "react-i18next";
import axios from "axios"

const getConfirmationIcon = (success) => {
    if (success) {
        return (<CheckIcon className="fraudStatusIcon" style={{ color: '#73C580', width: "40px", height: "40px" }} />)
    }
    else {
        return (<ClearIcon className="fraudStatusIcon" style={{ color: '#D91A1A', width: "40px", height: "40px" }} />)
    }
}

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

function ActiveRuleBatchChangeDialog(props) {
    const { t } = useTranslation();
    let { selectedEventTypes, user_data, rule_piece_key } = props

    const [batchChanges, dispatchBatchChanges] = useReducer(
        dataFetchReducer,
        { isLoading: false, isError: false, finished: false }
    )

    const [activeRuleBatchChangeDialogLoading, setActiveRuleBatchChangeDialogLoading] = useState(false)
    const [companiesWithoutActiveRule, setCompaniesWithoutActiveRule] = useState([])


    const handleCloseDialog = () => {
        props.onClose()
    }

    const handleBatchChange = () => {
        setActiveRuleBatchChangeDialogLoading(true)

        let payload = {
            'change_location': 'end',
        }

        let formattedCompanyEvents = []

        if (!user_data.business_group_key) {
            formattedCompanyEvents = selectedEventTypes.map(event => ({ 'event_type': event.enum }))
        } else {
            selectedEventTypes.forEach(event => {
                event.companies.filter(comp => comp.checked).forEach(comp => {
                    formattedCompanyEvents.push(
                        {
                            "company_key": comp.company_key,
                            "event_type": event.enum
                        }
                    )
                })
            })
        }

        payload['company_events'] = formattedCompanyEvents

        const timer = setTimeout(() => {
            axios
                .put(`/dash/rule_engine/rule_piece/${rule_piece_key}/batch_change`, payload)
                .then((response) => {
                    dispatchBatchChanges({
                        type: "data_fetch_success",
                        payload: payload,
                    });
                })
                .catch((error) => {
                    const errorBody = (error.response || {}).data || {}
                    if ((error.response || {}).status === 403)
                        dispatchBatchChanges({ type: "data_fetch_failure_403" });
                    else if ((error.response || {}).status === 404) {
                        if (errorBody.title === "Active rule not found")
                            setCompaniesWithoutActiveRule([...new Set((errorBody.description || []).map(invalidRule => invalidRule.company))])
                        dispatchBatchChanges({ type: "data_fetch_failure_404" });
                    }
                    else dispatchBatchChanges({ type: "data_fetch_failure" });
                })
                .finally(() => {
                    setActiveRuleBatchChangeDialogLoading(false)
                })
        }, 500);
        return () => {
            clearTimeout(timer);
        };
    }

    return (
        <Dialog
            open={props.open}
            onClose={handleCloseDialog}
            keepMounted={false}
        >
            <DialogTitle style={{ paddingBottom: "0px" }} className={["blueText", "normalMediumSize"].join(" ")}>{t("Alteração nas regras ativas")}</DialogTitle>
            <DialogContent>

                {
                    activeRuleBatchChangeDialogLoading
                        ?
                        <div
                            style={{
                                width: "366px", height: "80px",
                                display: "flex", flexDirection: "column",
                                marginBottom: "30px", alignItems: "center"
                            }}
                        >
                            <CircularProgress style={{ margin: "auto" }} />
                        </div>
                        :
                        batchChanges.isError
                            ?
                            <div
                                style={{
                                    width: "366px", height: "auto", minHeight: "220px",
                                    display: "flex", flexDirection: "column",
                                    marginBottom: "30px", alignItems: "center"
                                }}
                            >
                                <div className="internalCardContainer" style={{ display: "flex", height: "40%", justifyContent: "center" }}>
                                    {getConfirmationIcon(false)}
                                </div>
                                <div
                                    className={["internalCardContainer", "normalText", "normalMediumSize"].join(" ")}
                                    style={{ width: "90%", textAlign: "center" }}>
                                    <strong>{t("Erro ao atualizar as regras ativas")}</strong>
                                </div>
                                {
                                    companiesWithoutActiveRule.length > 0 &&
                                    <div
                                        className={["internalCardContainer", "normalText", "normalMediumSize"].join(" ")}
                                        style={{ width: "90%", textAlign: "center", marginTop: "0" }}>
                                        <p>{t("active_rule_batch_change_companies_without_active_rule")}</p>
                                        <ul style={{ textAlign: "left", margin: "0 auto", maxHeight: "150px", overflowY: "auto" }}>
                                            {companiesWithoutActiveRule.map(companyName => (
                                                <li key={companyName}><strong>{companyName}</strong></li>
                                            ))}
                                        </ul>
                                    </div>
                                }
                                <div className="internalCardContainer" style={{ display: "flex", marginTop: "10px" }}>
                                    <div
                                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                        style={{ width: "120px" }}
                                        onClick={handleCloseDialog}
                                    >
                                        {t("Fechar")}
                                    </div>
                                </div>
                            </div>
                            :
                            batchChanges.fetchedData ?
                                <div
                                    style={{
                                        width: "366px", height: "220px",
                                        display: "flex", flexDirection: "column",
                                        marginBottom: "30px", alignItems: "center"
                                    }}
                                >
                                    <div className="internalCardContainer" style={{ display: "flex", height: "40%", justifyContent: "center" }}>
                                        {getConfirmationIcon(true)}
                                    </div>
                                    <div
                                        className={["internalCardContainer", "normalText", "normalMediumSize"].join(" ")}
                                        style={{ width: "90%", textAlign: "center" }}>
                                        <strong>{t("Regras ativas foram atualizadas!")}</strong>
                                    </div>
                                    <div className="internalCardContainer" style={{ display: "flex", marginTop: "10px" }}>
                                        <div
                                            className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                            style={{ width: "120px" }}
                                            onClick={handleCloseDialog}
                                        >
                                            {t("Fechar")}
                                        </div>
                                    </div>
                                </div>
                                :
                                <div
                                    style={{
                                        width: "450px", height: "auto",
                                        display: "flex", flexDirection: "column",
                                        marginBottom: "20", alignItems: "center"
                                    }}
                                >
                                    <div
                                        className={["internalCardContainer", "normalText", "normalMediumSize", "blueText"].join(" ")}
                                        style={{ width: "90%", textAlign: "center" }}>
                                        <strong>{t("Atenção!")}</strong>
                                    </div>
                                    <div
                                        className={["internalCardContainer", "normalText", "normalMediumSize"].join(" ")}
                                        style={{ width: "90%", textAlign: "center", marginTop: '0' }}
                                    >
                                        <p>{t('active_rule_batch_change_intro')}</p>
                                        <strong><p>{t('active_rule_batch_change_count')}: <span>{!user_data.business_group_key ? (selectedEventTypes.map(event => (event)) || []).length : (selectedEventTypes.flatMap(event => event.companies.filter(comp => comp.checked)) || []).length}</span></p></strong>
                                    </div>
                                    <div className="internalCardContainer" style={{ display: "flex", marginTop: "10px" }}>
                                        <div
                                            className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                            style={{ width: "120px" }}
                                            onClick={handleCloseDialog}
                                        >
                                            {t("Voltar")}
                                        </div>
                                        <div
                                            className={["button", "standard", "normalText", "normalMediumSize"].join(" ")}
                                            style={{ width: "120px" }}
                                            onClick={handleBatchChange}
                                        >
                                            {t("Confirmar")}
                                        </div>
                                    </div>
                                </div>
                }
            </DialogContent>
        </Dialog>
    )
}

export default ActiveRuleBatchChangeDialog;